export default __webpack_public_path__ + "static/media/Use Case 3 .dc16a57b.svg";